<template>
  <div class="sidebar">
    <div class="sidebar--logo-wrapper">
      <a href="#">
        <img src="../../asset2/img/logo.png" alt="Company logo">
      </a>
    </div>
    <div class="sidebar--menu">
      <ul>
        <li>
          <a class="sidebar--menu--link_active sidebar--menu--link" href="#/dashboard/list">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17">
              <path d="M10,20V14h4v6h5V12h3L12,3,2,12H5v8Z" transform="translate(-2 -3)"/>
            </svg>
          </a>
        </li>
        <li>
          <a class="sidebar--menu--link" href="#/users/list">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
              <path
                  d="M546,186.943h-.583v-1.912H546V182h0v3.031h2.068v-2.864h2.014v2.864h2.644v1.912h-2.644v2.988h-2.014v-2.988H546v0ZM536,192v-6h8v6Zm0-8V174h8v10Zm10-4v-6h8v6Z"
                  transform="translate(-536 -174)"/>
            </svg>
          </a>
        </li>
        <li>
          <a class="sidebar--menu--link" href="#">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
              <path
                  d="M11.99,2A10,10,0,1,0,22,12,10,10,0,0,0,11.99,2ZM12,20a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm.5-13H11v6l5.25,3.15L17,14.92l-4.5-2.67Z"
                  transform="translate(-2 -2)"/>
            </svg>
          </a>
        </li>
        <li>
          <a class="sidebar--menu--link" href="#">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.209" height="19.504"
                 viewBox="0 0 17.209 19.504">
              <path d="M15.784,6.295,15.325,4H5V23.5H7.295V15.473h6.425l.459,2.295h8.031V6.295Z"
                    transform="translate(-5 -4)"/>
            </svg>
          </a>
        </li>
        <li>
          <a class="sidebar--menu--link" href="#/statistic/list">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
              <path
                  d="M20.94,11A8.994,8.994,0,0,0,13,3.06V1H11V3.06A8.994,8.994,0,0,0,3.06,11H1v2H3.06A8.994,8.994,0,0,0,11,20.94V23h2V20.94A8.994,8.994,0,0,0,20.94,13H23V11ZM12,19a7,7,0,1,1,7-7A6.995,6.995,0,0,1,12,19Z"
                  transform="translate(-1 -1)"/>
            </svg>
          </a>
        </li>
        <li>
          <a href="#" class="sidebar--menu--link">
            <svg id="Settings" xmlns="http://www.w3.org/2000/svg" width="19.882" height="19.882"
                 viewBox="0 0 19.882 19.882">
              <g id="icon_setting">
                <path id="Path_108" data-name="Path 108"
                      d="M16.527,6.462l1.367-2.61-1.74-1.74-2.61,1.367a4.451,4.451,0,0,0-1.367-.5L11.184,0H8.7L7.7,2.858a5.193,5.193,0,0,0-1.243.5L3.852,1.988,1.988,3.852l1.367,2.61a5.193,5.193,0,0,0-.5,1.243L0,8.7v2.485l2.858.994c.124.5.373.87.5,1.367l-1.367,2.61,1.74,1.74,2.61-1.367a4.452,4.452,0,0,0,1.367.5L8.7,19.882h2.485l.994-2.858c.5-.124.87-.373,1.367-.5l2.61,1.367,1.74-1.74-1.367-2.61a4.452,4.452,0,0,0,.5-1.367l2.858-.994V8.7L17.024,7.7A5.193,5.193,0,0,0,16.527,6.462ZM9.941,13.669A3.661,3.661,0,0,1,6.213,9.941,3.661,3.661,0,0,1,9.941,6.213a3.661,3.661,0,0,1,3.728,3.728A3.661,3.661,0,0,1,9.941,13.669Z"/>
              </g>
            </svg>
          </a>
        </li>
      </ul>
    </div>
    <div class="sidebar--expand-button">
      <button class="action-caller">
        <svg xmlns="http://www.w3.org/2000/svg" width="18.409" height="16.859" viewBox="0 0 18.409 16.859">
          <path id="expand_icon" data-name="expand icon"
                d="M544,188.878l6.435-6.449L544,175.981,545.981,174l8.429,8.429-8.429,8.429Zm-8,0,6.434-6.449L536,175.981,537.98,174l8.429,8.429-8.429,8.429Z"
                transform="translate(-536 -174)"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>

  require('../../asset2/css/main.min.css');

  export default {
    name: 'SideBar',
    data() {
      return {
        items: [],
        expanded: 'aria-expanded'
      };
    },
    methods: {
      hasChild(item) {
        return item.children && item.children.length > 0;
      }
    },
    async mounted() {
    }
  };
</script>

<style scoped>

</style>
